import request from '@/utils/request'

// 分仓入库计划报
export function apiGetMesWarehouseEntryPlanList (query) {
	return request({
		url: `/mes/mesWarehouseEntryPlan/list`,
		method: 'get',
		params: query
	})
}

// 生成数据
export function apiGenerateData () {
	return request({
		url: `/mes/mesWarehouseEntryPlan/generateData`,
		method: 'post'
	})
}

// 推送全部数据
export function apiMesWarehouseEntryPlanPushAll () {
	return request({
		url: `/mes/mesWarehouseEntryPlan/pushAll`,
		method: 'put'
	})
}

// 更新数据
export function apiMesWarehouseEntryPlanRefresh () {
	return request({
		url: `/mes/mesWarehouseEntryPlan/refresh`,
		method: 'put'
	})
}

// 编辑数据
export function apiMesWarehouseEntryPlanUpdateData (data) {
	return request({
		url: `/mes/mesWarehouseEntryPlan/updateData`,
		method: 'post',
		data: data
	})
}

// 查询分仓入库计划新增列表
export function apiMesWarehouseEntryPlanAddList () {
	return request({
		url: `/mes/mesWarehouseEntryPlan/addList`,
		method: 'get'
	})
}

// 新增数据
export function apiMesWarehouseEntryPlanAddData (data) {
	return request({
		url: `/mes/mesWarehouseEntryPlan/addData`,
		method: 'post',
		data: data
	})
}

// 批量更新计划入库日期
export function apiMesWarehouseEntryPlanUpdateBatchData (data) {
	return request({
		url: `/mes/mesWarehouseEntryPlan/updateBatchData`,
		method: 'post',
		data: data
	})
}
